<div class="page-container">
  @if (!isLoading) {
    <div class="page-navigation">
      <div class="circle-large" (click)="onCancel()">
        <div class="circle-icon">
          <i class="fa-regular fa-arrow-left fa-xl"></i>
        </div>
      </div>
      <div class="buttons">
        <button
          type="button"
          class="inwi-icon-text-button-medium-secondary"
          (click)="onCancel()">
          <div class="button-content">
            <i class="fa-regular fa-xmark button-icon"></i>
            <div class="button-text">Abbrechen</div>
          </div>
        </button>
        <button
          [disabled]="true"
          matTooltip="Diese Funktion ist noch nicht verfügbar"
          type="button"
          class="inwi-icon-text-button-medium-secondary"
          (click)="onPreview()">
          <div class="button-content">
            <i class="fa-regular fa-eye button-icon"></i>
            <div class="button-text">Vorschau</div>
          </div>
        </button>
        @if (editMode) {
          <button
            type="button"
            class="inwi-icon-text-button-medium-primary"
            (click)="onPublish()">
            <div class="button-content">
              <i class="fa-regular fa-floppy-disk button-icon"></i>
              <div class="button-text">Speichern</div>
            </div>
          </button>
        } @else {
          <button
            type="button"
            class="inwi-icon-text-button-medium-primary"
            (click)="onPublish()">
            <div class="button-content">
              <i class="fa-regular fa-check-double button-icon"></i>
              <div class="button-text">Veröffentlichen</div>
            </div>
          </button>
        }
        <button
          type="button"
          class="inwi-icon-button-medium-secondary"
          (click)="categoryMenu.toggle($event)">
          <i class="fa-regular fa-ellipsis-vertical button-icon"></i>
        </button>

        <p-menu #categoryMenu [model]="categoryMenuItems" [popup]="true">
          <ng-template pTemplate="item" let-item>
            <a
              pRipple
              class="flex align-items-center p-menu-item-link icon-24"
              [routerLink]="item.link"
              [queryParams]="item.queryParams">
              <i [class]="item.icon"></i>
              <span class="ml-2">{{ item.label }}</span>
            </a>
          </ng-template>
        </p-menu>
      </div>
    </div>

    <div
      class="font-bold-display-medium gap-8 flex-r align-center padding-16-0">
      @if (editMode) {
        <i class="fa-regular fa-pen title-icon"></i>
        <span class="font-bold-display-medium"> Kategorie bearbeiten</span>
      } @else {
        <i class="fa-regular fa-plus title-icon"></i>
        <span class="font-bold-display-medium"> Kategorie hinzufügen</span>
      }
    </div>

    <div class="flex-c align-center">
      <form
        class="flex-c justify-center"
        style="max-width: 800px; width: 100%"
        [formGroup]="trainingCategoryForm">
        <div
          class="input-formular-title align-self-stretch padding-36-0"
          [class.input-not-empty]="trainingCategoryForm.value.name !== ''">
          <input
            type="search"
            class="input-field"
            placeholder="Name der Fortbildung"
            formControlName="name" />
        </div>

        <div class="flex-c gap-24">
          <div class="input-colors flex-c gap-24">
            <span class="font-medium-headline-medium"> Farben </span>
            <div class="color-pickers flex-r gap-16 flex-wrap">
              <app-color-picker
                title="Tonal 50"
                [color]="trainingCategoryForm.get('color50').value"
                (colorSelected)="
                  trainingCategoryForm.get('color50').setValue($event)
                "></app-color-picker>
              <app-color-picker
                title="Tonal 0"
                [color]="trainingCategoryForm.get('color0').value"
                (colorSelected)="
                  trainingCategoryForm.get('color0').setValue($event)
                "></app-color-picker>
              <app-color-picker
                title="Tonal 70"
                [color]="trainingCategoryForm.get('color70').value"
                (colorSelected)="
                  trainingCategoryForm.get('color70').setValue($event)
                "></app-color-picker>
              <app-color-picker
                title="Tonal 80"
                [color]="trainingCategoryForm.get('color80').value"
                (colorSelected)="
                  trainingCategoryForm.get('color80').setValue($event)
                "></app-color-picker>
              <app-color-picker
                title="Tonal 90"
                [color]="trainingCategoryForm.get('color90').value"
                (colorSelected)="
                  trainingCategoryForm.get('color90').setValue($event)
                "></app-color-picker>
            </div>
          </div>
          <div class="input-simple align-self-stretch">
            <div class="input-label-wrapper">
              <label for="description" class="input-label">
                Beschreibung <b>(Fettgedruckt)</b>
                {{
                  fieldRequired(trainingCategoryForm.get('descriptionBold'))
                    ? '*'
                    : ''
                }}
              </label>
            </div>
            <input
              id="descriptionBold"
              name="descriptionBold"
              class="input-textarea"
              rows="4"
              placeholder="Beschreibung (Fettgedruckt)"
              formControlName="descriptionBold" />
            <app-error-message
              [formField]="
                trainingCategoryForm.get('descriptionBold')
              "></app-error-message>
          </div>
          <div class="input-simple align-self-stretch">
            <div class="input-label-wrapper">
              <label for="description" class="input-label">
                Beschreibung{{
                  fieldRequired(trainingCategoryForm.get('description'))
                    ? '*'
                    : ''
                }}
              </label>
              <div class="input-label-hint">
                {{
                  getTextAreaLength(
                    trainingCategoryForm.controls['description']
                  )
                }}
                /
                {{
                  getMaxLengthFromValidator(
                    trainingCategoryForm.controls['description']
                  )
                }}
              </div>
            </div>
            <textarea
              id="description"
              name="description"
              class="input-textarea"
              rows="4"
              placeholder="Beschreibung"
              formControlName="description"></textarea>
            <app-error-message
              [formField]="
                trainingCategoryForm.get('description')
              "></app-error-message>
          </div>
          <div class="flex-c align-start gap-24 align-self-stretch">
            <span class="font-medium-headline-large font-color-black">
              Sponsoren
            </span>
            <div class="flex-c align-start gap-16 align-self-stretch">
              <div class="input-simple align-self-stretch">
                <div class="input-label-wrapper">
                  <label for="description" class="input-label">
                    Sponsor Cards{{
                      fieldRequired(trainingCategoryForm.get('sponsorCards'))
                        ? '*'
                        : ''
                    }}
                  </label>
                </div>
                <p-multiSelect
                  [options]="sponsorCardOptions"
                  formControlName="sponsorCards"
                  placeholder="Sponsor auswählen"
                  optionValue="id"
                  optionLabel="title">
                  <ng-template let-value pTemplate="selectedItems">
                    <div class="flex-r align-center gap-4">
                      @for (option of value; track $index) {
                        <img
                          [attr.src]="
                            option.image ??
                            'assets/images/image-placeholder.svg'
                          "
                          class="multiselect-image" />
                        <div>
                          {{ option.title
                          }}{{ $index < value.length - 1 ? ', ' : '' }}
                        </div>
                      }
                    </div>
                    @if (!value || value.length === 0) {
                      <div>Sponsor auswählen</div>
                    }
                  </ng-template>
                  <ng-template let-card pTemplate="item">
                    <div class="sponsor-card">
                      <img
                        [attr.src]="
                          card.image ?? 'assets/images/image-placeholder.svg'
                        "
                        class="image" />
                      <div class="text">
                        <div class="title">{{ card.title }}</div>
                        <div class="description">
                          {{ card.description }}
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template let-card pTemplate="footer">
                    <b>
                      {{
                        trainingCategoryForm.get('sponsorCards').value
                          ? trainingCategoryForm.get('sponsorCards').value
                              .length
                          : 0
                      }}
                    </b>
                    {{
                      (trainingCategoryForm.get('sponsorCards').value
                        ? trainingCategoryForm.get('sponsorCards').value.length
                        : 0) === 1
                        ? 'Sponsor Card'
                        : 'Sponsor Cards'
                    }}
                    ausgewählt.
                  </ng-template>
                </p-multiSelect>
                <app-error-message
                  [formField]="
                    trainingCategoryForm.get('sponsorCards')
                  "></app-error-message>
              </div>
            </div>
          </div>
          <div class="input-picture flex-c gap-24">
            <span class="font-medium-headline-medium">
              Bild der Fortbildung
            </span>
            <div class="add-picture">
              <div class="upload-area cursor-pointer">
                <button class="circle-xsmall border-none">
                  <div class="circle-icon">
                    <i class="fa-regular fa-plus"></i>
                  </div>
                </button>
              </div>
              <div class="title font-medium-headline-small">
                Bild hinzufügen
              </div>
            </div>
          </div>
        </div>
      </form>
      <div style="padding-bottom: 20px"></div>
    </div>
  } @else {
    <div class="loading-wrapper">
      <mat-progress-spinner color="primary" mode="indeterminate" diameter="100">
      </mat-progress-spinner>
    </div>
  }
</div>
